

export default function maskSensitiveInfo(str) {

    if(str)
        return str = str.replace(/(.{3}$)/, "***");
    else
        return str
}
